import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MatterDate } from '../../../models/matter-date';

import { AlertService } from '../../../services/common/alert.service';
import { MatterDateService } from '../../../services/matters/matter-date.service';

@Component({
  selector: 'app-matter-date-form',
  templateUrl: './matter-date-form.component.html',
  styleUrls: ['./matter-date-form.component.css'],
})
export class MatterDateFormComponent implements OnInit {
  @Input() matter_id: number;

  @Input() matter_date_id: number;

  @Output() formResult: EventEmitter<string> = new EventEmitter();

  form_options: any = {
    matter_date_types: [],
  };

  dates: any = {};

  matter_date: MatterDate = new MatterDate();

  formSubmitting: boolean = false;
  formSubmitted: boolean = false;

  constructor(private alertService: AlertService, private matterDateService: MatterDateService) {
    this.matterDateService.getFormOptions().then((response_json) => {
      this.form_options = response_json;
      if (!this.matter_date_id) this.matter_date.matter_date_type_id = this.form_options.matter_date_types[0].id;
    });
  }

  ngOnInit() {
    if (this.matter_date_id)
      this.matterDateService.getMatterDate(this.matter_date_id).then((response_json) => {
        this.matter_date = response_json;
      });
    else if (this.matter_id) this.matter_date.matter_id = this.matter_id;
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  saveMatterDate(formValid: boolean) {
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      let scope = this;
      this.matterDateService
        .saveMatterDate(this.matter_date)
        .then((response_json) => {
          this.formSubmitting = false;
          if (response_json.text == 'Matter date created' || response_json.text == 'Matter date updated') {
            this.alertService.alert_status_success(response_json.text);
            this.formResult.emit('Form Saved');
          } else this.alertService.alert_status_danger(response_json.text || 'Error saving matter date');
        })
        .catch(function () {
          scope.formSubmitting = false;
          scope.alertService.alert_status_danger('Error saving matter date');
        });
    }
  }

  cancelForm() {
    this.formResult.emit('Form Cancelled');
  }
}
